import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const Slide05Teachers: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-full px-16">
      <div className="flex items-center gap-16 max-w-6xl">
        {/* Left: Stats and benefits */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="flex-1"
        >
          <h2 className="text-5xl font-bold text-white mb-4">
            Built for Teachers
          </h2>
          <p className="text-2xl text-[#94a3b8] mb-8">
            Your classroom assistant that gives you time back
          </p>

          <div className="mb-10">
            <div className="text-7xl font-black text-[#10b981]">10+</div>
            <div className="text-2xl text-white">Hours saved weekly</div>
            <div className="text-lg text-[#64748b]">on marking and admin tasks</div>
          </div>

          <div className="space-y-4">
            {[
              'Automated marking with instant feedback',
              'AI-powered lesson plan suggestions',
              'Early intervention alerts',
              'One dashboard for all student data',
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 + i * 0.1 }}
                className="flex items-center gap-3"
              >
                <CheckCircleIcon className="w-7 h-7 text-[#10b981] flex-shrink-0" />
                <span className="text-xl text-[#e2e8f0]">{item}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Right: Dashboard mockup */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="w-[400px] flex-shrink-0 rounded-xl p-6"
          style={{
            background: 'rgba(16, 185, 129, 0.1)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
          }}
        >
          <div className="text-center mb-6">
            <div className="text-4xl mb-3">📊</div>
            <h3 className="text-2xl font-semibold text-white">Live Class Dashboard</h3>
          </div>

          <div className="space-y-4">
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-lg text-[#94a3b8]">Class average mastery</span>
                <span className="text-xl text-white font-semibold">78%</span>
              </div>
              <div className="h-3 rounded-full bg-[#1e293b]">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: '78%' }}
                  transition={{ duration: 1, delay: 0.5 }}
                  className="h-full rounded-full bg-[#10b981]"
                />
              </div>
            </div>

            <div className="pt-4 border-t border-[#1e293b]">
              <div className="flex justify-between text-lg">
                <span className="text-[#f59e0b]">⚠️ 3 students need support</span>
              </div>
            </div>

            <div className="pt-4 border-t border-[#1e293b] space-y-2">
              <div className="flex justify-between">
                <span className="text-[#94a3b8]">Assignments completed</span>
                <span className="text-white font-semibold">24/28</span>
              </div>
              <div className="flex justify-between">
                <span className="text-[#94a3b8]">Avg. time on task</span>
                <span className="text-white font-semibold">18 min</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Slide05Teachers;
